export const UserRow = ({ currentUser, onRemove, onRoleChange, user }) => {
  const isCurrentUser = user.id === currentUser.id;

  return (
    <article className="list-group-item border-0 rounded">
      <div className="row g-3 align-items-center">
      <div className="col-auto">
        <div className="d-flex align-items-center justify-content-center rounded bg-green text-white fw-bold user-avatar">
        {getInitials(user.username)}
        </div>
      </div>

      <div className="col-12 col-md">
        <div className="d-flex flex-wrap align-items-center gap-2">
          <h5 className="m-0 text-break">{user.username}</h5>
          {isCurrentUser && <span className="badge bg-green">You</span>}
          {user.disabled && <span className="badge bg-secondary">Disabled</span>}
        </div>
        <p className="m-0 text-muted text-break">ID {user.id}</p>
      </div>

      <div className="col-12 col-md-3">
        <span className={user.role === 'admin' ? 'badge bg-dark mb-2' : 'badge bg-green mb-2'}>{getRoleLabel(user.role)}</span>
        <select
          className="form-select"
          value={user.role}
          onChange={(event) => onRoleChange(user.id, event.target.value)}
          disabled={isCurrentUser}
          aria-label={`Set role for ${user.username}`}
        >
          <option value="staff">Staff</option>
          <option value="admin">Admin</option>
        </select>
      </div>

      <div className="col-12 col-md-auto text-end">
        <button className="btn btn-danger w-100" type="button" onClick={() => onRemove(user.id)} disabled={isCurrentUser} aria-label={`Delete ${user.username}`}>
          <i className="bi bi-trash3" />
        </button>
      </div>
      </div>
    </article>
  );
}

function getInitials(username = '') {
  const [name = 'U'] = username.split('@');
  return name.slice(0, 2).toUpperCase();
}

function getRoleLabel(role) {
  return role === 'admin' ? 'Admin' : 'Staff';
}
